import React, { useState, useEffect } from 'react';
import SalesInventoryMain from './SalesInventoryMain';
import CustomerManagement from './CustomerManagement';
import ReferenceManagement from './ReferenceManagement';
import AgentManager from './AgentManager'; 
import CommissionSale from './CommissionSale';
import { THEME } from '../../constants/theme';

const SalesmanPanel = () => {
    const [activeTab, setActiveTab] = useState('inventory');

    // 🛑 Purchase style lock: Body scroll ko disable karna
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = 'auto'; };
    }, []);

    const tabs = [
        { id: 'inventory', label: 'Sales', icon: '📦' },
        { id: 'customers', label: 'Customers', icon: '👥' },
        { id: 'references', label: 'References', icon: '🔗' },
        { id: 'agents', label: 'Agents', icon: '🕵️' },
        { id: 'commission_sale', label: 'Commission Sale', icon: '🚀' }
    ];

    return (
        /* Purchase wala style: styles.wrapper */
        <div style={styles.wrapper}>
            <style>{`
                .no-scrollbar::-webkit-scrollbar { display: none; }
                * { box-sizing: border-box; }
            `}</style>
            
            {/* Purchase wala style: styles.container */}
            <div style={styles.container}>
                
                {/* 📌 Top Menu - Purchase style background and padding */}
                <div className="no-scrollbar" style={styles.topMenu}>
                    {tabs.map((tab) => (
                        <div 
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            style={{
                                ...styles.menuItem,
                                borderBottom: activeTab === tab.id ? `3px solid ${THEME.secondary || '#3b82f6'}` : '3px solid transparent',
                                color: activeTab === tab.id ? (THEME.secondary || '#3b82f6') : '#64748b',
                                backgroundColor: activeTab === tab.id ? '#f8fafc' : 'transparent',
                            }}
                        >
                            <span style={{ fontSize: '16px' }}>{tab.icon}</span>
                            <span>{tab.label}</span>
                        </div>
                    ))}
                </div>

                {/* 📌 Content Area - Purchase style flex-1 and overflow auto */}
                <div style={styles.contentArea}>
                    {activeTab === 'inventory' && <SalesInventoryMain />}
                    {activeTab === 'customers' && <CustomerManagement />}
                    {activeTab === 'references' && <ReferenceManagement />}
                    {activeTab === 'agents' && <AgentManager />}
                    {activeTab === 'commission_sale' && <CommissionSale />}
                </div>
            </div>
        </div>
    );
};

// ==========================================
// 🎨 EXACT PURCHASE PANEL STYLES
// ==========================================
const styles = {
    wrapper: { height: '100%', display: 'flex', flexDirection: 'column' },
    container: { display: 'flex', flexDirection: 'column', backgroundColor: '#fff', borderRadius: '16px', overflow: 'hidden', flex: 1, border: '1px solid #e2e8f0' },
    topMenu: { display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#fff' },
    menuItem: { display: 'flex', alignItems: 'center', padding: '18px 25px', cursor: 'pointer', gap: '10px', fontWeight: 'bold', fontSize: '14px', transition: '0.3s' },
    contentArea: { flex: 1, padding: '25px', backgroundColor: '#f8fafc', overflowY: 'auto' },
    statsRow: { display: 'flex', gap: '20px', marginBottom: '25px' },
    statCard: { background: '#fff', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', flex: 1 },
    statLabel: { fontSize: '11px', fontWeight: '900', color: '#64748b', textTransform: 'uppercase' },
    statValue: { fontSize: '24px', fontWeight: '900', color: '#1e293b', display: 'block' },
    searchInput: { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontSize: '14px' },
    tableCard: { background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden' },
    table: { width: '100%', borderCollapse: 'collapse' },
    thead: { background: '#f8fafc', borderBottom: '1px solid #e2e8f0' },
    th: { padding: '15px', textAlign: 'left', fontSize: '11px', color: '#64748b', textTransform: 'uppercase' },
    tr: { borderBottom: '1px solid #f1f5f9', transition: '0.2s' },
    td: { padding: '15px', fontSize: '13px' },
    loader: { padding: '40px', textAlign: 'center', color: '#64748b' },
    statusBadge: { background: '#dcfce7', color: '#166534', padding: '4px 10px', borderRadius: '6px', fontSize: '10px', fontWeight: 'bold' },
    viewBtn: { padding: '8px 15px', background: '#1e293b', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px' },
    searchBtn: { padding: '0 25px', background: '#1e293b', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' },
    saveBtn: { width: '100%', padding: '15px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', marginTop: '15px' },
    paginationRow: { padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff' },
    pageBtn: { padding: '6px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: '12px' }
};

export default SalesmanPanel;